import firebase, {db, auth, fc, st} from './connection'
import store from '../store.js'

export default {
    uploadFile(uid, guid, item, info) {
		let ref = db.collection('users').doc(uid).collection('work');
		let uploadTask = st.ref(uid + '/work/' + guid).put(item);

        store.dispatch('setFileUploading', true);
        store.dispatch('setFileUploaded', false);

		uploadTask.on('state_changed', snapshot => {
						let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        store.dispatch('setFileProgress', progress);
					}, error => {
                        console.log(error);
                        store.dispatch('setFileUploading', false);
					}, () => {
                        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                                ref.add({
                                        name: guid,
                                        url: downloadURL,
                                        title: info.title,
                                        date: info.date,
                                        description: info.description
                                    })
                                    .then( () => {
                                        store.dispatch('setFileUploading', false);
                                        store.dispatch('setFileUploaded', true);
                                    })
                                    .catch( error => {
                                        console.log(error);
                                    });
                            });
					});
    },

    uploadTeamFile(user, guid, item, info) {
        let ref = db.collection('teams').doc(info.team).collection('work');
		let uploadTask = st.ref(info.team + '/work/' + guid).put(item);

        store.dispatch('setFileUploading', true);
        store.dispatch('setFileUploaded', false);

		uploadTask.on('state_changed', snapshot => {
						let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        store.dispatch('setFileProgress', progress);
					}, error => {
                        console.log(error);
                        store.dispatch('setFileUploading', false);
					}, () => {
                        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                                ref.add({
                                        name: guid,
                                        url: downloadURL,
                                        title: info.title,
                                        date: info.date,
                                        description: info.description,
                                        category: info.category,
                                        uploadedBy: {
                                            uid: user.uid,
                                            name: user.name
                                        }
                                    })
                                    .then( () => {
                                        store.dispatch('setFileUploading', false);
                                        store.dispatch('setFileUploaded', true);
                                    })
                                    .catch( error => {
                                        console.log(error);
                                    });
                            });
					});
    },

    uploadPDA(uid, guid, item) {
		let ref = db.collection('users').doc(uid)
		let uploadTask = st.ref(uid + '/' + guid).put(item);

        store.dispatch('setFileUploading', true);
        store.dispatch('setFileUploaded', false);

		uploadTask.on('state_changed', snapshot => {
						let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        store.dispatch('setFileProgress', progress);
					}, error => {
                        console.log(error);
                        store.dispatch('setFileUploading', false);
					}, () => {
                        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                                ref.update({
                                        pda: downloadURL
                                    })
                                    .then( () => {
                                        store.dispatch('setFileUploading', false);
                                        store.dispatch('setFileUploaded', true);
                                    })
                                    .catch( error => {
                                        console.log(error);
                                    });
                            });
					});
    },
    
    removeFile(uid, fileName) {
		let tempo = st.ref(uid + '/work/' + fileName);
		tempo.delete();

		let ref = db.collection('users').doc(uid);

		return ref.update({photo: null})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },
    
    getAll(uid) {
        let ref = db.collection('users').doc(uid).collection('work')
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getAllFromTeam(id) {
        let ref = db.collection('teams').doc(id).collection('work');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getComments(idTeam, idFile) {
        let ref = db.collection('teams').doc(idTeam).collection('work').doc(idFile).collection('comments');

        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    addComment(user, idTeam, idFile, comment) {
        let ref = db.collection('teams').doc(idTeam).collection('work').doc(idFile).collection('comments');

        let obj = {
            comment: comment,
            date: Date.now(),
            user: {
                uid: user.uid,
                name: user.name
            }
        }

        return ref.add(obj)
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

    removeComment(idTeam, idFile, idComment) {
        let ref = db.collection('teams').doc(idTeam).collection('work').doc(idFile).collection('comments').doc(idComment);

        return ref.delete()
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    }

}